import React, { useEffect, useState } from 'react'

export interface ButtonProps {
  children?: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: ((event: any) => void) ;
  lang?: string;
  isMbpRedirect?: boolean;
}

export const Button = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, ButtonProps>(({
  children,
  href,
  className = '',
  lang,
  isMbpRedirect = false,
  ...props
}, ref) => {
  const [hrefState, setHrefState] = useState(href)
  useEffect(() => {
    if (isMbpRedirect) {
      setHrefState(href + '&mbp_redirect=' + encodeURIComponent(window.location.href))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href, isMbpRedirect, href])

  return (
    href
      ? <a className={className} lang={lang} ref={ref as React.RefObject<HTMLAnchorElement>} href={hrefState} {...props}>{children}</a>
      : <button className={className} lang={lang} type='button' ref={ref as React.RefObject<HTMLButtonElement>} {...props}>{children}</button>
  )
})
